<template>
  <div class="app-container">
    <!-- <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item >
            <el-row>
              <el-col :span="11">
                <el-time-select v-model="
                        listQuery.start_time
                      " style="width: 100%" :picker-options="{
                        start: '00:00',
                        step: '00:10',
                        end: '24:00',
                      }" placeholder="选择视频开始时间"></el-time-select>
              </el-col>
              <el-col :span="2" style="text-align: center">-</el-col>
              <el-col :span="11">
                <el-time-select v-model="
                        listQuery.end_time
                      " style="width: 100%" :picker-options="{
                        start: '00:00',
                        step: '00:10',
                        end: '24:00',
                      }" placeholder="选择视频结束时间"></el-time-select>
              </el-col>
            </el-row>
          </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div> -->
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button v-auth="'Space.create'" class="action-item" type="primary" icon="el-icon-edit" @click="HandleCreate">添加</el-button>
        <el-button v-auth="'Space.delete'" class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>
        <el-button type="success" @click="goBack()">返回场地</el-button>
      </el-button-group>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <el-table-column type="selection"></el-table-column>
      <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
      <el-table-column align="center" prop="site_name" label="所属门店"> </el-table-column>
      <el-table-column align="center" prop="space_name" label="所属场地"> </el-table-column>
      <el-table-column align="center" prop="serial_name" label="设备名称"> </el-table-column>
      <el-table-column align="center" prop="serial_number" label="设备序列号"> </el-table-column>
      <el-table-column align="center" prop="create_time" label="创建时间 "> </el-table-column>
      <el-table-column align="center" prop="" label="操作" width="200" class-name="action">
        <template slot-scope="scopes">
          <el-button v-auth="'Space.update'" icon="el-icon-edit" type="primary" size="mini" @click="HandleUpdate(scopes.row)">编辑</el-button>
          <el-button v-auth="'Space.delete'" icon="el-icon-delete" size="mini" type="danger" @click="RowDelete(scopes.row)">删除</el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="110px" style="width: 100%;">
        <el-form-item label="设备名称" prop="serial_name">
          <el-input v-model="temp.serial_name" placeholder="请输入设备名称" />
        </el-form-item>
        <el-form-item label="设备序列号" prop="serial_number">
          <el-input v-model="temp.serial_number" placeholder="请输入设备序列号" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="save()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/site/spaceSerial' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
export default {
  name: 'Space',
  components: { Pagination },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {
        serial_name: [{ required: true, message: '请输入设备名称', trigger: 'blur,change' }],
        serial_number: [{ required: true, message: '请输入设备序列号', trigger: 'blur,change' }]
      },
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id'
      }
    }
  },
  created() {
    this.listQuery.site_id = this.$route.query.site_id
    this.listQuery.space_id = this.$route.query.id
    this.loadData()
  },
  methods: {
    // 条件过滤查询
    SearchData() {
      this.listQuery.site_id = this.$route.query.site_id
      this.listQuery.space_id = this.$route.query.id
      this.listQuery.page = 1
      this.loadData()
    },
    // 显示编辑窗体
    HandleUpdate(row) {
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
    },
    goBack() {
      this.$router.push({ path: '/site/space' })
    },
    // 提交
    save() {
      this.temp.space_id = this.$route.query.id
      this.temp.site_id = this.$route.query.site_id
      const obj = { ...this.temp }
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          api.Create(obj).then((response) => {
            this.$notify({
              title: '成功',
              message: response.msg,
              type: 'success',
              duration: 2000
            })
            this.loadData()
            this.dialogFormVisible = false
          })
        }
      })
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 99999
      }
    }
  }
}
</script>
